<template>
<panel>
  <p slot="header">
    {{ item.title }} <span class="gray">(wiadomość)</span>
  </p>
  <p slot="actions">
    <ui-button type="flat" color="primary" icon="navigate_before" @click="$router.push({name: 'admin.messages.show', params: {id: item.id}})">Anuluj</ui-button>
  </p>
  <messages-form :item="item" v-if="item.id"></messages-form>
</panel>

</template>
<script>
import Messages from './../../services/Messages'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Messages.getBaseItem()
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getItem(id)
  },
  methods: {
    cancel () {
      this.$router.push({name: 'admin.messages.dashboard', params: {id: this.item.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Messages.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Edit.vue?6dd14fcd